export default "__VITE_ASSET__CPFwnrbb__"